// dependencies.
import token from './token'
import flatten from './flatten'

/**
 * Request interceptors.
 *
 * @param http
 * @param store
 * @param router
 */
export default (http, store, router) => {
  // flatten data
  http.interceptors.response.use(flatten.success, flatten.error)

  // set authorization token.
  http.interceptors.request.use(token(store, router), error => error)
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors/index.js